/* Memoria: on mobile the product photo frame takes the height of the photo in view
   (styles in mj-pdp-gallery.css). Like the Van der Kooij gallery, the target photo is
   chosen as soon as you swipe past halfway and the frame animates to its height once.
   Only the frame (slider-component) is resized, never the scrolling strip, so iOS
   scroll-snap always lands cleanly on a photo. Dots under the photos (like TOV) show
   the number of photos and the one in view; tapping a dot goes to that photo. */
(function () {
  if (window.mjGalleryReady) return;
  window.mjGalleryReady = true;
  var mq = window.matchMedia('(max-width: 749px)');
  var EN = /^en/i.test(document.documentElement.lang || ''); /* /en/: Engels, anders NL */

  function setup(list) {
    var frameEl = list.closest('slider-component') || list.parentElement;
    var dots = document.createElement('div');
    dots.className = 'mj-gallery-dots';
    dots.setAttribute('aria-label', EN ? 'Product photos' : 'Productfoto\'s');
    frameEl.insertAdjacentElement('afterend', dots);
    var raf;

    function slides() {
      return [].filter.call(list.children, function (li) { return li.offsetWidth > 0; }); /* skip hidden variant photos */
    }
    function nearestIndex(items) {
      var start = items[0].offsetLeft;
      var x = list.scrollLeft;
      var best = 0;
      var dist = Infinity;
      items.forEach(function (li, i) {
        var d = Math.abs(li.offsetLeft - start - x);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }
    function renderDots(items, index) {
      if (dots.children.length !== items.length) {
        dots.innerHTML = '';
        items.forEach(function (li, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', (EN ? 'Photo ' : 'Foto ') + (i + 1) + (EN ? ' of ' : ' van ') + items.length);
          b.addEventListener('click', function () {
            var all = slides();
            if (!all[i]) return;
            list.scrollTo({ left: all[i].offsetLeft - all[0].offsetLeft, behavior: 'smooth' });
          });
          dots.appendChild(b);
        });
      }
      dots.hidden = items.length < 2;
      [].forEach.call(dots.children, function (b, i) {
        if (i === index) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }
    function update() {
      raf = null;
      var items = slides();
      var h = '';
      if (mq.matches && items.length) {
        var index = nearestIndex(items);
        if (items[index].offsetHeight) h = items[index].offsetHeight + 'px';
        renderDots(items, index);
      }
      if (frameEl.style.height !== h) frameEl.style.height = h;
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }

    list.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    list.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', schedule);
    });
    /* A variant change swaps which photos are shown */
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    update();
  }

  /* Chain products (gold chains *-gold-chain-*, NL silver chains zilver-collier / zilver-collier-statement): the side view of the chain always
     stays first, followed by the photo of the chosen length only. Dawn puts the photo of
     the selected variant first and hides the other variant photos; here the side view
     is moved back in front and the chosen length photo stays visible behind it. */
  var chainPage = /\/products\/[^/?#]*(gold-chain|zilver-collier(?:-statement)?(?:[/?#]|$))/.test(location.pathname);
  function chainOrder(list) {
    var first = list.firstElementChild;
    if (!first || !first.classList.contains('product__media-item--variant')) return;
    var lead = list.querySelector('.product__media-item:not(.product__media-item--variant)');
    if (!lead) return;
    [].forEach.call(list.querySelectorAll('.mj-cur'), function (li) { li.classList.remove('mj-cur'); });
    first.classList.add('mj-cur');
    list.prepend(lead);
  }
  function setupChain(list) {
    if (!list.querySelector('.product__media-item--variant')) return;
    list.classList.add('mj-chain-gallery');
    chainOrder(list);
    if (window.MutationObserver) new MutationObserver(function () { chainOrder(list); }).observe(list, { childList: true });
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper .product__media-list').forEach(function (list) {
      if (list.dataset.mjGallery) return;
      list.dataset.mjGallery = '1';
      if (chainPage) setupChain(list);
      setup(list);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
